import { type ReactNode } from 'react';
import { Configure, InstantSearch, InstantSearchSSRProvider } from 'react-instantsearch';

import { useFragmentContext } from '@jsmdg/react-fragment-scripts/fragment';
import { enhanceAlgoliaAnalyticsTags } from '@jsmdg/tracking';
import { Breakpoint, useBreakpoint } from '@jsmdg/yoshi';
import { useAlgolia } from '../../hooks/useAlgolia';
import { type ProductDetailContext } from '../../types/types';

const AlgoliaWrapper = ({ children }: { readonly children: ReactNode }): JSX.Element => {
    const { algoliaConfig, locale, product, tenant } = useFragmentContext<ProductDetailContext>();
    const { client, indexName } = useAlgolia({
        locale,
        tenant,
        algoliaConfig,
    });
    const isDesktop = useBreakpoint(Breakpoint.SM);

    return (
        /* eslint-disable-next-line react/jsx-props-no-spreading */
        <InstantSearchSSRProvider {...algoliaConfig.serverState}>
            <InstantSearch
                searchClient={client}
                indexName={indexName}
                // We need InstantSearchWrapper for insights. Only execute searches if searchEnabled
                searchFunction={(helper): void => {
                    if (algoliaConfig.searchEnabled) helper.search();
                }}
            >
                <Configure
                    userToken={algoliaConfig.userToken}
                    analyticsTags={enhanceAlgoliaAnalyticsTags({
                        isDesktop,
                        analyticsTags: [product.productId],
                    })}
                    hitsPerPage={0}
                />
                {children}
            </InstantSearch>
        </InstantSearchSSRProvider>
    );
};

export { AlgoliaWrapper };
